import { styled } from "styled-components";

import { colorCSS, fontSizes, theme } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const CalculatorHeading = styled.div`
    ${redundantCssFromKebab("border-bottom", `1px solid ${colorCSS("N40")}`)}
    ${redundantCssFromKebab("font-family", `${theme.fontFamily.display}`)}
    ${redundantCssFromKebab("font-weight", "500")}
    ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
    ${redundantCssFromKebab("line-height", "1.33333333")}
    ${redundantCssFromKebab("margin-bottom", "1rem")}
    ${redundantCssFromKebab("padding-bottom", "0.5rem")}
`;

export const NumberInput = styled.input`
    ${redundantCssFromKebab("background", `${colorCSS("N20")}`)}
    ${redundantCssFromKebab("border", `1px solid ${colorCSS("N40")}`)}
    ${redundantCssFromKebab("border-radius", "6px")}
    ${redundantCssFromKebab("margin-bottom", "0.5rem")}
    ${redundantCssFromKebab("padding", "0.4rem 0.8rem")}
    ${redundantCssFromKebab("width", "100%")}
    ${redundantCssFromKebab("transition", "250ms ease-out")}
    &:focus {
        ${redundantCssFromKebab("border-color", `${colorCSS("B300", 0.5)}`)}
        ${redundantCssFromKebab(
            "box-shadow",
            `0 0 0 3px ${colorCSS("B300", 0.15)}`
        )}
        ${redundantCssFromKebab("outline", "none")}
    }
`;

export const PriceContainer = styled.div`
    ${redundantCssFromKebab("margin-top", "1rem")}
`;

export const PriceGrid = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-wrap", "wrap")}

    > div {
        ${redundantCssFromKebab("min-width", "50%")}
    }

    > div:first-of-type {
        ${redundantCssFromKebab("padding-right", "1rem")}
    }
`;

export const PriceItem = styled.div`
    ${redundantCssFromKebab("margin-bottom", "1rem")}
`;

export const PriceLabel = styled.div`
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
`;

export const Price = styled.div`
    small {
        ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
    }

    span {
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.display}`)}
        ${redundantCssFromKebab("font-weight", "500")}
        ${redundantCssFromKebab("font-size", `${fontSizes.xxl}`)}
        ${redundantCssFromKebab("margin-left", "0.25rem")}
        ${redundantCssFromKebab("margin-right", "0.25rem")}
    }
`;

export const InfoLabel = styled.div`
    ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
`;
